import { lazy } from "react";

export const AttributeListPage = lazy(() => import("./attributes-list-page"));
export { DYNAMIC_ATTRIBUTES_LIST_PAGE } from "./attributes-list-page-path";
